// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-7865daa5]{display:flex;align-items:center;padding:0;max-width:320px;border:1px solid #ced0d5;background-color:#fff}.search i[data-v-7865daa5]{width:50px;text-align:center;opacity:.5}.search input[data-v-7865daa5]{border:0;flex:1 1 auto;height:100%;outline:none;height:calc(1em + 2.4rem + 2px);padding:0}", ""]);
// Exports
module.exports = exports;
